<div>
	<!-- <ion-toolbar color="primary"> -->
	<h4>Devices</h4>
	<!-- </ion-toolbar> -->
</div>

@if (deviceIds == null) {
<p>Loading...</p>
}

<mat-grid-list [cols]="1">
	@if (deviceIds != null) {
<div
	
		class="wrapper">
		<huge-row>
			@for (id of deviceIds; track id) {
<span
			
				class="id-section">
				<p (click)="getDeviceData(id)">{{ id }}</p>
			</span>
}
		</huge-row>
	</div>
}
</mat-grid-list>
